import { useEffect, useRef } from 'react';
import EventEmitter from '@24i/nxg-core-utils/src/eventEmitter';
import { log } from '@24i/nxg-core-utils/src/logger';
import { CUSTOM_EVENT } from '@24i/nxg-core-utils/src/constants';
import { useFeature } from '../../context/AppSettingsData';
import { useUserQuery } from '../query/user/useUserQuery';

interface IdentityProviderValidationProps {
    onLogout?: (options?: Record<string, unknown>) => Promise<void>;
}

export const useIdentityManagerValidation = (options?: IdentityProviderValidationProps) => {
    const identityProvider = useFeature('identityProvider');
    const timeoutId = useRef<ReturnType<typeof setTimeout> | undefined>();
    const isLogoutAvailable = useRef(true);
    const { user } = useUserQuery();

    useEffect(() => {
        if (!identityProvider?.enabled || !identityProvider?.baseUrl) return undefined;

        const handler = () => {
            if (isLogoutAvailable.current && user) {
                isLogoutAvailable.current = false;

                if (options && options.onLogout) {
                    options?.onLogout().catch(log);
                }

                timeoutId.current = setTimeout(() => {
                    isLogoutAvailable.current = true;
                }, 5000); // prevent multiple calls within 5 seconds
            }
        };
        EventEmitter.add(CUSTOM_EVENT.INVALID_AUTHENTICATION, handler);
        return () => {
            EventEmitter.remove(CUSTOM_EVENT.INVALID_AUTHENTICATION, handler);
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
            isLogoutAvailable.current = true;
        };
    }, [identityProvider, user]);
};
